var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg27IconHeart = function Svg27IconHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.415 4.5c-.648 0-1.256.25-1.71.706a2.431 2.431 0 0 0 0 3.43L9 13.939l5.295-5.303a2.431 2.431 0 0 0 0-3.43c-.91-.912-2.511-.91-3.42 0L9.53 6.552a.77.77 0 0 1-1.062 0L7.125 5.205a2.398 2.398 0 0 0-1.71-.705M9 15.75a.747.747 0 0 1-.53-.22L2.644 9.695a3.935 3.935 0 0 1 0-5.55A3.891 3.891 0 0 1 5.414 3a3.89 3.89 0 0 1 2.772 1.145L9 4.961l.814-.815A3.89 3.89 0 0 1 12.586 3a3.89 3.89 0 0 1 2.77 1.145 3.933 3.933 0 0 1 0 5.55L9.532 15.53a.75.75 0 0 1-.531.22",
    fill: "none",
    fillRule: "evenodd"
  })));
};

export default Svg27IconHeart;